export default __webpack_public_path__ + "static/media/delievers18.94201717.jpeg";